/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { hooks as commonHooks, types as commonTypes } from '@sitebuilder/common';
const CHILDREN_PLACEHOLDER_ID = 'children';

interface WidgetProperties extends commonTypes.WidgetPropertiesBase {
    id?: string;
    className?: string;
}

const ReferenceComponent = (props: commonTypes.WidgetInstanceProps) => {
    const widgetInstance = commonHooks.useWidgetInstance(props.widgetInstanceId);
    const { Placeholder } = commonHooks.useAppContext();

    const { styles, id, className } =
        commonHooks.useWidgetProperties<WidgetProperties>(props.widgetInstanceId) || {};

    const { data } = props;

    return (
        <div
            id={id}
            className={`refereneComponent ${className || ''}`}
            css={css`
                ${styles}
            `}
        >
            <Placeholder
                contentPlaceHolderId={CHILDREN_PLACEHOLDER_ID}
                parentWidgetInstanceId={widgetInstance.id}
                data={data}
            />
        </div>
    );
};

export default ReferenceComponent;
